import { createAction } from '@reduxjs/toolkit';

export const SHOW_MESSAGE_NOTIFICATION_ACTION_TYPE = 'saga/showMessageNotification';
export const showMessageNotificationAction = createAction(SHOW_MESSAGE_NOTIFICATION_ACTION_TYPE);
